import Http from "@/commons/Http";
import Utils from "@/commons/Utils.js";

const path = 'api/folha-seguranca';

export default {

  async getFolhasByLoteId(loteId){
    if(!Utils.testUUID(loteId)){
      return Promise.reject();
    }
    return Http.get(`${path}/get-folhas-by-lote/${loteId}`);
  },

  async vincularFolhasSegurancaCertidao(certidao, protocoloId){
    return Http.post(`${path}/vincular-folhas-seguranca-certidao/${protocoloId}`, certidao);
  },

  async getFolhasUtilizadasCertidao(certidaoId){
    return Http.get(`${path}/get-folhas-utilizadas-certidao/${certidaoId}`);
  },

  async previewFolhasCertidao(certidaoId){
    return Http.get(`${path}/preview-folhas-certidao/${certidaoId}`);
  },

  async atualizarStatusFolhas(folhas, loteId){
    return Http.post(`${path}/atualizar-status-folhas/${loteId}`, folhas);
  },

  async vincularCertidaoManual(folhaId, numeroCertidao, atribuicao) {
    return Http.post(`${path}/${folhaId}/vincular-certidao-manual`, { numeroCertidao, atribuicao });
  },

  async desvincularCertidao(folhaId) {
    return Http.post(`${path}/${folhaId}/desvincular-certidao`);
  },

  async validarCertidaoManual(numeroCertidao, atribuicao) {
    return Http.post(`${path}/validar-certidao-manual`, { numeroCertidao, atribuicao });
  },

  async salvarGestao(folhas, loteId) {
    return Http.post(`${path}/salvar-gestao/${loteId}`, folhas);
  }

}
